export const isSuccess = (resp) => {
  if (resp && resp.code === 'SUCCESS') {
    return true
  }
  return false
}
